// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"225":"4691246a","838":"4547c5bb"}[chunkId] + ".js";
};